import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function Subscribers({ onClose }) {
  const [subscribers, setSubscribers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetch() {
      const { data } = await supabase
        .from('subscribers')
        .select('*')
        .eq('active', true)
        .order('created_at', { ascending: false })
      setSubscribers(data || [])
      setLoading(false)
    }
    fetch()
  }, [])

  async function remove(id) {
    await supabase.from('subscribers').update({ active: false }).eq('id', id)
    setSubscribers(prev => prev.filter(s => s.id !== id))
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="subscribers-modal" onClick={e => e.stopPropagation()}>
        <div className="imgmgr-header">
          <div>
            <h2 className="imgmgr-title">Subscribers</h2>
            {!loading && (
              <p className="subscribers-count">{subscribers.length} active</p>
            )}
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="subscribers-body">
          {loading && <div className="loading">Loading…</div>}
          {!loading && subscribers.length === 0 && (
            <p className="subscribers-empty">No subscribers yet. Share your subscribe link to get started.</p>
          )}
          {!loading && subscribers.length > 0 && (
            <>
              <div className="subscribers-link-bar">
                <span className="editor-label">Subscribe link</span>
                <code className="subscribers-link">{window.location.origin}/subscribe</code>
              </div>
              <div className="subscribers-list">
                {subscribers.map(s => (
                  <div key={s.id} className="subscriber-row">
                    <div>
                      <p className="subscriber-email">{s.email}</p>
                      <p className="subscriber-date">
                        Joined {new Date(s.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </p>
                    </div>
                    <button className="subscriber-remove" onClick={() => remove(s.id)} title="Unsubscribe">✕</button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
